export const PEPVIGIL = 'PEPVIGIL';
export const retrainingTagsKey = ['retraining_storage_acc_name', 'retraining_container_name', 'retraining_blob_path', 'retraining_sas_token'];
export const smartSamplingTagsKey = ['source_account', 'source_container', 'source_subpath', 'output_account', 'output_container', 'output_subpath'];
export default {};
